/* ============================================================================
   tcs-bn.js · Black November 2026 · kampagnelag for The Copenhagen Scent
   ----------------------------------------------------------------------------
   Kører kun når html[data-tcs-bn-phase] er sat (se snippets/tcs-bn-config.liquid).
   Fasen (teaser/bn/bw/cm) afgøres i browseren i dansk tid, så midnatsskift sker
   uden at vente på Shopifys sidecache. Alt tekst og alle tal ligger her, så
   Liquid kun leverer skelet, billeder og kurvens antal.

   Priser: 50 ml 299 (før-pris) → 239 / 194 / 164, 100 ml 399 → 319 / 259 / 219 (pr. flaske
   ved 1–2 / 3–4 / 5+). De to automatiske rabatter er 17,9 % og 30,6 % oven på
   kampagneprisen (18,8 % og 31,4 %), så begge størrelser rammer præcis 20/35/45 % af 299/399.
   ============================================================================ */
(function () {
  'use strict';
  var C = window.TCS_BN;
  if (!C || !C.phase || C.phase === 'off') return;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PRICE = C.price;
  var pct = function (n) { return n >= 5 ? 45 : n >= 3 ? 35 : 20; };
  var per = function (size, n) { var t = PRICE[size].t; return t[Math.min(Math.max(n, 1), 5) - 1]; };
  var dk = function (n) { return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
  var P = function (n) { return dk(n) + '<small>,-</small>'; };
  var Ptxt = function (n) { return dk(n) + ',-'; };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var setHTML = function (el, h) { if (el && el.innerHTML !== h) el.innerHTML = h; };
  var setText = function (el, t) { if (el && el.textContent !== t) el.textContent = t; };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var sale = function () { return C.phase !== 'teaser'; };
  // Badge: rabatten er helten. mod = 20/35/45 styrer farven, label er den lille linje under.
  var badge = function (pc, label, extra) { return '<b>−' + pc + ' %</b>' + (label ? '<small>' + label + '</small>' : ''); };
  var badgeClass = function (el, pc, extra) { el.className = el.className.replace(/\btcs-bn-badge--(20|35|45|off)\b/g, '').replace(/\s+/g, ' ').trim() + ' tcs-bn-badge--' + pc + (extra ? ' ' + extra : ''); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* ---------- nedtælling: altid til noget, der faktisk sker ---------- */
  var CD = {
    teaser: { end: C.dates.bn, lbl: 'Black November starter om' },
    bn: { end: C.dates.bw, lbl: 'Black Week begynder om' },
    bw: { end: C.dates.cm, lbl: 'Black Week slutter søndag kl. 23:59' },
    cm: { end: C.dates.end, lbl: 'Slutter i nat kl. 23:59' }
  };
  function cdParts() {
    var s = Math.max(0, Math.floor((Date.parse(CD[C.phase].end) - Date.now()) / 1000));
    return { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
  }
  function cdText() { var c = cdParts(); return (c.d ? c.d + ' d ' : '') + pad(c.h) + ':' + pad(c.m) + ':' + pad(c.s); }
  function cdRow() {
    var c = cdParts();
    return '<p class="tcs-bn-cdl">' + CD[C.phase].lbl + '</p><div class="tcs-bn-cdrow" data-bn-cdrow>' +
      '<div><b>' + c.d + '</b><span>DAGE</span></div><div><b>' + pad(c.h) + '</b><span>TIMER</span></div>' +
      '<div><b>' + pad(c.m) + '</b><span>MIN</span></div><div><b>' + pad(c.s) + '</b><span>SEK</span></div></div>';
  }
  function tick() {
    $$('[data-bn-cd]').forEach(function (e) { e.textContent = cdText(); });
    var row = $('[data-bn-cdrow]');
    if (row) { var c = cdParts(); var v = [c.d, pad(c.h), pad(c.m), pad(c.s)]; $$('b', row).forEach(function (e, i) { e.textContent = v[i]; }); }
  }

  /* ---------- tekster pr. fase ---------- */
  var H1 = {
    teaser: ['Fra 1. november: jo flere dufte i pakken, jo mindre koster hver flaske.', 'Alle 43 dufte. Op til 45 %. Få besked, når det starter.'],
    bn: ['Jo flere dufte i pakken, jo mindre koster hver flaske.', ''],
    bw: ['Black Week. Sidste uge med pakkepriserne.', ''],
    cm: ['Sidste dag. Pakkepriserne slutter i nat.', '']
  };
  function topbarHTML() {
    var p = C.phase;
    if (p === 'teaser') return '<span>Black November starter <b>1. november</b> · op til 45 %</span><span class="tcs-bn-cd">om <span data-bn-cd>' + cdText() + '</span></span>';
    if (p === 'bn') {
      // Nedtælling først når den betyder noget: under 3 dage til Black Week. Ellers kun tilbuddet.
      var soon = cdParts().d < 3;
      return '<span>Jo flere dufte, jo billigere bliver hver flaske</span><span><b>Op til 45 % rabat</b> · Black November</span>' + (soon ? '<span class="tcs-bn-cd">Black Week om <span data-bn-cd>' + cdText() + '</span></span>' : '');
    }
    if (p === 'bw') return '<span><b>Black Week</b> · op til 45 % · slutter søndag kl. 23:59</span>';
    return '<span><b>Cyber Monday</b> · sidste dag med op til 45 % · slutter kl. 23:59</span>';
  }
  function say(size, n) {
    var w = PRICE[size].was, u = per(size, n);
    if (!sale()) return '<b>' + n + (n > 1 ? ' dufte:' : ' duft:') + '</b> ' + Ptxt(w) + ' pr. stk i dag. Fra 1. november ' + Ptxt(u) + '.';
    var m = {
      1: '<b>1 duft til ' + Ptxt(u) + '.</b> Vælg 3, og få −35 % på alle. Fri fragt fra 3.',
      2: '<b>2 dufte: −20 %.</b> Én mere, og du får −35 % på alle tre og fri fragt.',
      3: '<b>3 dufte: ' + Ptxt(3 * u) + ' i alt.</b> Du sparer ' + dk(3 * w - 3 * u) + ' kr. Fri fragt.',
      4: '<b>4 dufte: −35 %.</b> Én mere, og du får −45 % på alle fem.',
      5: '<b>5 dufte: ' + Ptxt(5 * u) + ' i alt.</b> Du sparer ' + dk(5 * w - 5 * u) + ' kr. Mere bliver det ikke.'
    };
    return m[n];
  }

  /* ---------- topbar ---------- */
  function renderTopbar() {
    $$('[data-tcs-bn-topbar]').forEach(function (el) { el.innerHTML = topbarHTML(); el.hidden = false; });
  }

  /* ---------- hero (forsiden) v3: tre trin (1/3/5) i stedet for skyder og flaskerække ----------
     Rabatten er det store element i hvert trin, prisen pr. flaske står under. 3 er valgt fra start.
     Knappen ruller ned til "Vælg dine dufte", hvor + fylder pakken. ---------- */
  var hero = { n: 5, size: 50 }; // standardvalg 5 dufte (Omar 4/11)
  function scrollToPicks() { var p = picksRoot(); if (p) p.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
  function renderTiers() {
    var n = hero.n, size = hero.size, sp = sale(), w = PRICE[size].was;
    $$('[data-bn-tiers] .tcs-bn-tier').forEach(function (t) {
      var q = Number(t.getAttribute('data-tier')), on = q === n, u = sp ? per(size, q) : w;
      t.setAttribute('aria-checked', String(on)); t.classList.toggle('is-on', on);
      var pc = $('[data-bn-tier-pct]', t); if (pc) { pc.hidden = !sp; if (sp) { pc.innerHTML = badge(pct(q)); badgeClass(pc, pct(q)); } }
      var pr = $('[data-bn-tier-price]', t); if (pr) pr.innerHTML = P(u);
    });
    renderSizeSeg();
  }
  function renderHero() {
    var root = $('[data-tcs-bn-hero]'); if (!root) return;
    root.hidden = false;
    var n = hero.n, size = hero.size, sp = sale();
    var h1 = $('[data-bn-h1]', root); if (h1) h1.textContent = H1[C.phase][0];
    var sub = $('[data-bn-sub]', root); if (sub) { sub.textContent = H1[C.phase][1]; sub.hidden = !H1[C.phase][1]; }
    var sy = $('[data-bn-say]', root); if (sy) sy.innerHTML = say(size, n);
    var cta = $('[data-bn-cta]', root); if (cta) cta.textContent = sp ? 'Vælg dine ' + n + (n > 1 ? ' dufte' : ' duft') : 'Se alle dufte';
    var fine = $('[data-bn-fine]', root); if (fine) fine.textContent = '50 ml og 100 ml tæller sammen. Rabatten trækkes i kurven.';
    var ex = $('[data-bn-extra]', root);
    if (ex) { if (C.phase === 'bw' || C.phase === 'cm') { if (!ex.querySelector('[data-bn-cdrow]')) ex.innerHTML = cdRow(); } else ex.innerHTML = ''; }
  }
  // Ét kald tegner hele tilbuddet: trin, hero, kollektionshoved, pakke og Krown-kortenes priser.
  function renderOffer() { renderTiers(); renderHero(); renderColhead(); renderPicks(); }
  function initHero() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-bn-tiers] .tcs-bn-tier'); if (t) { hero.n = Number(t.getAttribute('data-tier')) || 5; renderOffer(); return; }
      var sb = e.target.closest && e.target.closest('[data-bn-sizeseg] button'); if (sb) { hero.size = Number(sb.getAttribute('data-size')) || 50; renderOffer(); return; }
      if (e.target.closest && e.target.closest('[data-bn-cta]')) { e.preventDefault(); scrollToPicks(); }
    });
    renderOffer();
  }

  /* ---------- Klaviyo-tilmelding i teaseren ---------- */
  function subscribe(form) {
    var input = form.querySelector('input[type=email]'); var msg = $('[data-bn-form-msg]');
    var email = (input.value || '').trim();
    var show = function (t) { if (msg) { msg.textContent = t; msg.hidden = false; } };
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { show('Skriv en gyldig e-mail.'); input.focus(); return; }
    if (!C.klaviyo || !C.klaviyo.company || !C.klaviyo.list) { show('Tilmelding er ikke sat op endnu (Klaviyo-id mangler i temaindstillingerne).'); return; }
    var btn = form.querySelector('button'); btn.disabled = true;
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(C.klaviyo.company), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Black November 2026 teaser', profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: C.klaviyo.list } } } } })
    }).then(function (r) {
      if (r.status === 202 || r.ok) { form.innerHTML = '<p class="tcs-bn-form__msg" style="margin:0">Tak. Du hører fra os kl. 00:01 den 1. november.</p>'; }
      else { show('Det lykkedes ikke. Prøv igen om lidt.'); btn.disabled = false; }
    }).catch(function () { show('Det lykkedes ikke. Prøv igen om lidt.'); btn.disabled = false; });
  }

  /* ---------- kollektionshoved ---------- */
  function renderColhead() {
    $$('[data-tcs-bn-colhead]').forEach(function (root) {
      var sp = sale(), n = hero.n, size = hero.size;
      root.hidden = false;
      var h = $('[data-bn-colh]', root); if (h) h.textContent = C.phase === 'bw' ? 'Black Week: sidste uge med 3 for −35 % og 5 for −45 %.' : C.phase === 'cm' ? 'Sidste dag: 3 for −35 %, 5 for −45 %. Slutter i nat.' : 'Vælg dine dufte. 3 giver −35 %, 5 giver −45 %.';
      var sub = $('[data-bn-colsub]', root); if (sub) sub.textContent = sp ? 'Vælg antal, og tryk + på dine dufte herunder.' : 'Pakkepriserne starter 1. november.';
      var sy = $('[data-bn-colsay]', root); if (sy) sy.innerHTML = say(size, n);
    });
  }

  /* ---------- produktside: note under købsmodulets antal ---------- */
  function renderPDP() {
    var rows = $('[data-tcs-rows]');
    if (!rows || $('.tcs-bn-pdp-note')) return;
    var p = document.createElement('div');
    p.className = 'tcs-bn-pdp-note';
    var anchor = '';
    var pd = C.product;
    if (sale() && pd && pd.compare) {
      var mPrice = String(pd.compare).replace(/\./g, '').match(/(\d{3,5})\s*kr/i);
      var mName = String(pd.compare).match(/Inspireret af\s+([^(]+)\(/i) || String(pd.ref || '').match(/Inspireret af\s+(.+)/i);
      if (mPrice && mName) {
        var refName = mName[1].trim().replace(/\s+(EDP|EDT|Parfum|Eau de Parfum|Eau de Toilette)$/i, ''), refPrice = Number(mPrice[1]);
        anchor = '<p class="tcs-bn-anchor"><b>' + refName + '</b> koster ' + dk(refPrice) + ' kr. <b>' + pd.title + '</b> koster ' + Ptxt(per(50, 1)) + ', eller ' + Ptxt(per(50, 5)) + ' i en pakke på 5.</p>';
      }
    }
    p.innerHTML = sale()
      ? anchor + '<p class="tcs-bn-pdp-foot">50 og 100 ml tæller sammen i pakken. Rabatten trækkes i kurven.</p>'
      : '<p class="tcs-bn-pdp-foot">Fra 1. november: −35 % ved 3 dufte, −45 % ved 5.</p>';
    rows.parentNode.insertBefore(p, rows.nextSibling);
  }

  /* ---------- købsmodul (Growbix' fil, forkes ikke): pris pr. flaske i stedet for "x kr for 3. duft" ----------
     Modulet skriver sine egne tekster ved hvert valg, så vi retter efter det via en observer med vagt. */
  function fixModuleUnits() {
    if (!sale()) return;
    $$('tcs-buy-module [data-tcs-row-unit]').forEach(function (u) {
      var q = Number(u.getAttribute('data-tcs-row-unit')) || 0; if (q < 2) return;
      var tot = $('tcs-buy-module [data-tcs-row-total="' + q + '"]'); if (!tot) return;
      var kr = Number((tot.textContent || '').replace(/[^\d]/g, '')); if (!kr) return;
      var want = Math.round(kr / q) + ' kr pr. flaske';
      if (/ for \d+\. duft/.test(u.textContent) && u.textContent !== want) u.textContent = want;
    });

  }
  // Trin 1: størrelseskortenes pris, kr/ml og "x kr mere" følger det valgte antal (data-bn-units fra Liquid, øre pr. flaske for 1–5).
  function syncSizeCards() {
    var m = $('tcs-buy-module'); if (!m) return;
    var q = Number((m.querySelector('input[name="tcs-qty"]:checked') || {}).value) || 5, i = Math.min(Math.max(q, 1), 5) - 1;
    var cards = $$('label.tcs-card[data-bn-units]', m), units = {};
    cards.forEach(function (c) {
      var arr = c.getAttribute('data-bn-units').split(',').map(Number), u = arr[i] / 100, ml = Number(c.getAttribute('data-bn-ml')) || 50;
      if (!u) return; units[ml] = u;
      setText(c.querySelector('.tcs-card__price'), dk(u) + ' kr');
      var ue = c.querySelector('.tcs-card__unit'); if (ue && /kr\/ml/.test(ue.textContent)) setText(ue, (u / ml).toFixed(2).replace('.', ',') + ' kr/ml');
    });
    if (units[100] && units[50]) cards.forEach(function (c) { var n = c.querySelector('.tcs-card__note'); if (n) setText(n, 'Dobbelt størrelse. ' + dk(units[100] - units[50]) + ' kr mere.'); });
  }
  function initModule() {
    var m = $('tcs-buy-module'); if (!m) return;
    fixModuleUnits(); syncSizeCards();
    var busy = false;
    new MutationObserver(function () { if (busy) return; busy = true; try { fixModuleUnits(); syncSizeCards(); } finally { busy = false; } }).observe(m, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'tcs-qty') syncSizeCards(); });
  }

  /* ---------- Krowns produktkort: + (læg 50 ml i kurven) og niveaulinjen ----------
     Kører på alle sider med .product-item (kollektioner, forsidens kategorifaner).
     Variant-id hentes fra /products/<handle>.js ved klik, så vi ikke er afhængige af kortets markup. */
  var RATINGS = null;
  function ratings() {
    if (RATINGS) return RATINGS;
    RATINGS = {};
    $$('script[data-bn-ratings]').forEach(function (sc) { try { var o = JSON.parse(sc.textContent); for (var k in o) RATINGS[k] = o[k]; } catch (e) {} });
    return RATINGS;
  }
  function starsHTML(r) { return '<span class="tcs-bn-stars__i" aria-hidden="true">★</span> ' + (Math.round(r[0] * 10) / 10).toFixed(1).replace('.', ','); }
  function decorateCards() {
    if (!sale()) return;
    $$('.product-item:not([data-bn-card-done])').forEach(function (card) {
      card.setAttribute('data-bn-card-done', '1'); cardTap(card);
      var link = card.querySelector('a[href*="/products/"]'); if (!link) return;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); if (!m) return;
      var cap = (card.querySelector('.product-capacity') || {}).textContent || '';
      if (/x\s*5\s*ml/i.test(cap)) return; // prøvepakker tæller ikke med i pakken
      // Plusset lægges på selve kortet (ikke inde i billedlinket), så det aldrig konkurrerer med linkets
      // navigation eller Krowns billedlag. Kortet gøres position:relative i CSS.
      var img = card;
      card.setAttribute('data-bn-handle', m[1]);
      if (img && !img.querySelector(':scope > [data-bn-qa]')) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'tcs-bn-qa'; b.setAttribute('data-bn-qa', m[1]);
        var nmEl = card.querySelector('.product-title-wrapper span') || card.querySelector('.product-title-wrapper') || card.querySelector('.product-item__title'); var nm = nmEl ? nmEl.textContent.replace(/\s+/g, ' ').trim().split(' ★')[0] : '';
        b.setAttribute('aria-label', 'Læg ' + nm.trim() + ' i pakken'); b.textContent = '+';
        img.appendChild(b);
      }
      var r = ratings()[m[1]], title = card.querySelector('.product-item__title');
      if (r && title && !card.querySelector('.tcs-bn-stars')) {
        // Ved siden af navnet: Krowns titel-link har navnet i et span og størrelsen i .product-capacity
        var nameEl = title.querySelector('.product-title-wrapper span, .product-title-wrapper') || title;
        var st = document.createElement('span'); st.className = 'tcs-bn-stars tcs-bn-stars--card'; st.setAttribute('aria-label', 'Bedømmelse ' + r[0] + ' ud af 5'); st.innerHTML = starsHTML(r);
        nameEl.appendChild(st);
      }
      var price = card.querySelector('.product-price');
      if (price && !card.querySelector('.tcs-bn-card__lv')) {
        var lv = document.createElement('div'); lv.className = 'tcs-bn-card__lv'; lv.innerHTML = '<b>−35 %</b> ved 3 · <b>−45 %</b> ved 5';
        price.parentNode.insertBefore(lv, price.nextSibling);
      }
    });
  }
  function quickAdd(btn) {
    var handle = btn.getAttribute('data-bn-qa'); if (!handle || btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy'); btn.textContent = '…';
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var v = (p.variants || []).filter(function (x) { return /^50\s*ml$/i.test(x.title) && x.available; })[0] || (p.variants || []).filter(function (x) { return x.available && !/^5\s*ml$/i.test(x.title); })[0];
      if (!v) throw new Error('ingen variant');
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) });
    }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); }).then(function () {
      btn.classList.remove('is-busy'); btn.classList.add('is-done'); btn.textContent = '✓';
      setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = '+'; }, 1800);
      if (typeof window.refreshCart === 'function') { try { window.refreshCart(); } catch (err) {} }
      document.dispatchEvent(new CustomEvent('cart-updated'));
      var t = $('#site-header [data-js-sidebar-handle][aria-controls="site-cart-sidebar"], #site-header a.area--cart, #site-header a[href$="/cart"]');
      if (t) t.click();
    }).catch(function () { btn.classList.remove('is-busy'); btn.textContent = '+'; location.href = '/products/' + handle; });
  }
  function cardTap(card) {
    if (card.hasAttribute('data-bn-tap')) return; card.setAttribute('data-bn-tap', '1');
    card.addEventListener('click', function (e) {
      if (e.target.closest('a, button, input, select, label, [data-bn-qa]')) return;
      if (e.target.closest('.tcs-bn-card__lv')) { var qa = card.querySelector('[data-bn-qa]'); if (qa) qa.click(); return; }
      var a = card.querySelector('a.product-item__image, a[href*="/products/"]'); if (a) location.href = a.getAttribute('href');
    });
  }
  function initCards() {
    decorateCards();
    // Plusset ligger inde i Krowns produktlink, som navigerer allerede ved pointer-/touch-events.
    // Derfor stoppes alle faser i capture, og handlingen udføres på pointerup (klik som reserve).
    var qaOf = function (e) { return e.target && e.target.closest ? e.target.closest('[data-bn-qa]') : null; };
    var act = function (b) { if (packMode()) togglePick(b.getAttribute('data-bn-qa')); else quickAdd(b); };
    var acted = 0;
    ['pointerdown', 'mousedown', 'touchstart', 'touchend', 'mouseup'].forEach(function (ev) {
      document.addEventListener(ev, function (e) { if (qaOf(e)) { e.stopPropagation(); if (e.cancelable) e.preventDefault(); } }, { capture: true, passive: false });
    });
    document.addEventListener('pointerup', function (e) {
      var b = qaOf(e); if (!b) return;
      e.stopPropagation(); if (e.cancelable) e.preventDefault();
      acted = Date.now(); act(b);
    }, { capture: true, passive: false });
    document.addEventListener('click', function (e) {
      var b = qaOf(e); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      if (Date.now() - acted > 600) act(b); // browsere uden pointer events
    }, true);
    var main = document.querySelector('main') || document.body;
    var mo = new MutationObserver(function () { if ($('.product-item:not([data-bn-card-done])')) { decorateCards(); renderPicks(); } });
    mo.observe(main, { childList: true, subtree: true });
  }

  /* ---------- kurv: "Din pakke" + upsell med kun én besked ---------- */
  function renderCart() {
    // Ved hver kurvændring kommer en FRISK blok inde i upsell-containeren; den
    // gamle, allerede flyttede blok fjernes, så der aldrig står to.
    var all = $$('[data-tcs-bn-cart]'), block = null;
    if (all.length) {
      var fresh = all.filter(function (b) { return !!b.closest('[data-tcs-upsell]'); });
      block = fresh[0] || all[0];
      all.forEach(function (b) { if (b !== block && b.parentNode) b.parentNode.removeChild(b); });
    }
    if (block) {
      // Flyt blokken øverst i draweren (Liquid renderer den i upsell-containeren, som
      // Growbix' kode genindlæser ved hver kurvændring – så følger den altid kurven).
      var top = $('#site-cart-sidebar .sidebar__body-top');
      if (top && top.firstElementChild !== block) top.insertBefore(block, top.firstChild);
      var n = Number(block.getAttribute('data-n')) || 0;
      var n100 = Number(block.getAttribute('data-n100')) || 0;
      var size = n100 > n - n100 ? 100 : 50;
      var sp = sale();
      var isEmpty = !$('#site-cart-sidebar .cart-item'); // kurven er kun tom uden varelinjer; prøvepakker tæller ikke i pakken (n), men er stadig varer
      if (!sp || isEmpty || n === 0) { if (!block.hidden) block.hidden = true; } else if (block.hidden) block.hidden = false; // kun prøvepakker i kurven: ingen pakke-blok
      // Overskrift: "Din kurv (3)" i stedet for "Antal varer i kurv (3)".
      var ttl = $('#site-cart-sidebar .sidebar__title');
      if (ttl && sp && !ttl.hasAttribute('data-bn-done')) { var cnt = ttl.querySelector('[data-header-cart-count]'); ttl.textContent = 'Din kurv ('; if (cnt) ttl.appendChild(cnt); ttl.appendChild(document.createTextNode(')')); ttl.setAttribute('data-bn-done', '1'); }
      // Én linje under knappen, der tager de tre sidste bekymringer, lige dér hvor beslutningen tages.
      var fb = $('#site-cart-sidebar .flex-buttons');
      if (fb && sp && !$('#site-cart-sidebar [data-bn-trust]')) { var tr = document.createElement('p'); tr.className = 'tcs-bn-cart__trust'; tr.setAttribute('data-bn-trust', '1'); fb.parentNode.insertBefore(tr, fb.nextSibling); }
      var trEl = $('#site-cart-sidebar [data-bn-trust]'); if (trEl) setHTML(trEl, shipLine() + ' · ' + ((Number(block.getAttribute('data-total')) / 100 || 0) >= (Number(block.getAttribute('data-free')) / 100 || 499) ? 'Fri fragt' : 'Sikker betaling') + ' · Forlænget retur til 1. februar');
      // Contribe-widgetten (donation) hører til under USP-boksen, ikke mellem varerne og anbefalingerne.
      var cp = $('#site-cart-sidebar contribe-plugin'), usps = $('#site-cart-sidebar .tcs-cart-usps');
      if (cp && usps && cp.previousElementSibling !== usps) usps.parentNode.insertBefore(cp, usps.nextSibling);
      // Tom kurv: ikke en blindgyde. Én sætning om trinnene og én vej til duftene.
      var sbEl = $('#site-cart-sidebar'), emp = $('#site-cart-sidebar [data-bn-cart-empty]');
      if (sbEl && sp && isEmpty && !emp) {
        var topEl = $('#site-cart-sidebar .sidebar__body-top');
        if (topEl) { emp = document.createElement('div'); emp.className = 'tcs-bn-cart-empty'; emp.setAttribute('data-bn-cart-empty', '1');
          emp.innerHTML = '<p>Din kurv er tom.</p><p class="tcs-bn-cart-empty__s">3 dufte giver <b>−35 %</b>, 5 dufte giver <b>−45 %</b>.</p><a class="tcs-bn-cta" href="/collections/alle-33">Vælg dine dufte</a>';
          topEl.appendChild(emp); }
      } else if (emp && !isEmpty) { emp.parentNode.removeChild(emp); }
      if (sp && !isEmpty) {
        var total = Number(block.getAttribute('data-total')) / 100 || 0;   // kurvens pris efter rabat (kr)
        var free = Number(block.getAttribute('data-free')) / 100 || 499;   // fri fragt fra (kr)
        var next = n < 3 ? { need: 3 - n, u: per(size, 3) } : n < 5 ? { need: 5 - n, u: per(size, 5) } : null;
        // Førprisen for alt i pakken, linje for linje (50/100 ml), så "Du sparer" er ens i top og bund.
        var wasTotal = 0;
        $$('#site-cart-sidebar .cart-item').forEach(function (it) {
          var v = (it.querySelector('.cart-item__variant') || {}).textContent || '';
          var sz = /100/.test(v) ? 100 : /50/.test(v) ? 50 : 0; if (!sz) return;
          wasTotal += (Number(it.getAttribute('data-qty')) || 1) * PRICE[sz].was;
        });
        var saved = wasTotal > total ? wasTotal - total : 0;
        var freeNow = total >= free;
        var lines = $$('#site-cart-sidebar .cart-item').length;
        setText($('[data-bn-cart-title]', block), n + (n === 1 ? ' duft' : lines < n ? ' flasker' : ' dufte') + ' i pakken');
        var cbd = $('[data-bn-cart-badge]', block); if (cbd) { setHTML(cbd, badge(pct(n))); if (!cbd.classList.contains('tcs-bn-badge--' + pct(n))) badgeClass(cbd, pct(n)); }
        $$('[data-bn-cart-bar] i', block).forEach(function (t, i) { t.classList.toggle('is-on', i < n); });
        var nxEl = $('[data-bn-cart-nx]', block);
        if (nxEl) setHTML(nxEl, next
          ? 'Læg <b>' + next.need + ' mere</b> i, og alle får <b>−' + (n < 3 ? 35 : 45) + ' %</b>' + (!freeNow && n < 3 ? ' og fri fragt' : '') + '.'
          : '<b>−45 %</b> på alt. Hver flaske mere får det samme.');
        // Varelinjer: pris pr. flaske (fra cart.js) over den stregede førpris pr. flaske. Antallet står i tælleren.
        var lineEls = $$('#site-cart-sidebar .cart-item').filter(function (it) { return !it.querySelector('.cart-item__price[data-bn-done]'); });
        lineEls.forEach(function (it) {
          var v = (it.querySelector('.cart-item__variant') || {}).textContent || '';
          var sz = /100/.test(v) ? 100 : /50/.test(v) ? 50 : 0; if (!sz) return;
          var pr = it.querySelector('.cart-item__price'); if (!pr) return;
          var del = pr.querySelector('del');
          if (!del) { del = document.createElement('del'); var w = document.createElement('span'); w.appendChild(del); pr.appendChild(w); }
          del.textContent = dk(PRICE[sz].was) + ',00 kr'; pr.setAttribute('data-bn-done', '1');
          var vl = it.querySelector('.cart-item__variant'); if (vl) vl.textContent = vl.textContent.replace(/^\s*Størrelse:\s*/i, '').trim();
          var wrap = it.querySelector('.cart-item__content > div');
          if (sz === 50 && wrap && !wrap.querySelector('[data-bn-up]')) {
            var up = document.createElement('button'); up.type = 'button'; up.className = 'tcs-bn-up'; up.setAttribute('data-bn-up', '1');
            up.innerHTML = 'Skift til 100 ml · <b>+' + Ptxt(per(100, n) - per(50, n)) + ' pr. flaske</b>';
            wrap.appendChild(up);
          }
        });
        if (lineEls.length) getCart().then(function (cart) {
          $$('#site-cart-sidebar .cart-item').forEach(function (it) {
            var vid = Number(String(it.getAttribute('data-id')).split(':')[0]);
            var li = (cart.items || []).filter(function (i) { return i.variant_id === vid; })[0];
            var st = it.querySelector('.cart-item__price strong'); if (!li || !st) return;
            var unit = li.final_price / 100;
            st.textContent = dk(Math.floor(unit)) + ',' + ('0' + Math.round((unit % 1) * 100)).slice(-2) + ' kr';
          });
        }).catch(function () {});
        // Bundlinjen: totalen, "Du sparer" og Klarna uden beløb. Den stregede sum er skjult i CSS.
        var tot = $('#site-cart-sidebar .cart__total strong');
        if (tot && !tot.hasAttribute('data-bn-done')) {
          tot.setAttribute('data-bn-done', '1');
          var meta = $('#site-cart-sidebar .cart__meta'), svg = $('#site-cart-sidebar .cart__savings'), kl = $('#site-cart-sidebar .cart__klarna');
          if (kl) kl.innerHTML = 'Eller 3 rater med <strong>Klarna</strong>';
          if (saved > 0) { if (meta && !svg) { svg = document.createElement('span'); svg.className = 'cart__savings'; meta.appendChild(svg); } if (svg) svg.textContent = 'Du sparer ' + Ptxt(saved); }
        }
      // Growbix' anbefalings-slider har loading="lazy" på billederne; i en vandret slider i draweren
      // udløses de ikke altid ved første åbning. De første fire hentes med det samme.
      $$('#site-cart-sidebar .tcs-cart-upsell__img img').slice(0, 4).forEach(function (im) { if (im.loading === 'lazy') im.loading = 'eager'; });
      // Upsell-overskrift og -priser: hvad koster én mere i DIN pakke?
        var title = $('#site-cart-sidebar .tcs-cart-upsell__title');
        if (n === 0) { if (title) title.setAttribute('data-bn-done', '1'); $$('#site-cart-sidebar [data-tcs-upsell-price]').forEach(function (p) { p.setAttribute('data-bn-done', '1'); }); }
        else if (title) { setText(title, next ? (next.need === 1 ? 'Én mere' : next.need + ' mere') + ', og du får −' + (n < 3 ? 35 : 45) + ' % på alle' + (n === 2 ? ' og fri fragt' : '') : 'Plads til flere'); title.setAttribute('data-bn-done', '1'); }
        if (n > 0) $$('#site-cart-sidebar .tcs-cart-upsell__item').forEach(function (it) {
          var sel = it.querySelector('[data-tcs-upsell-select]'); var pr = it.querySelector('[data-tcs-upsell-price]');
          if (sel) { // 5 ml sælges ikke i kampagnen: fjern den som valg (lagertal røres ikke)
            var had5 = false;
            $$('option', sel).forEach(function (o) { if (/\b5\s?ml\b/i.test(o.textContent) && sel.options.length > 1) { if (o.selected) had5 = true; o.remove(); } });
            if (had5 && sel.options.length) { sel.selectedIndex = 0; sel.dispatchEvent(new Event('change', { bubbles: true })); return; }
          }
          if (!pr) return;
          var opt = sel && sel.selectedOptions && sel.selectedOptions[0] ? sel.selectedOptions[0].textContent : '50 ml';
          var sz = /100/.test(opt) ? 100 : /50/.test(opt) ? 50 : 0;
          if (!sz) return; // 5 ml eller prøvepakker tæller ikke
          setHTML(pr, P(per(sz, n + 1)) + '<small>i din pakke</small>'); if (!pr.hasAttribute('data-bn-done')) pr.setAttribute('data-bn-done', '1');
        });
      }
    }
  }

  // Skal kurven tegnes igen? Kun når Growbix' container har leveret en frisk blok,
  // eller upsell-elementer endnu ikke er skrevet om. Ellers ville vores egne
  // DOM-ændringer udløse observeren i en uendelig løkke.
  // Ét /cart.js-kald ad gangen (flere dele af draweren spørger inden for samme sekund).
  var cartP = null, cartAt = 0;
  function getCart(fresh) {
    var now = Date.now();
    if (!fresh && cartP && now - cartAt < 400) return cartP;
    cartAt = now;
    return cartP = fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }
  // Pakke-blokken opdateres med det samme fra cart.js, så kunden ikke venter ~1 s på, at
  // Growbix' sektion genindlæses. Når den friske Liquid-blok kommer, viser den det samme.
  function syncFromCart() {
    return getCart(true).then(function (cart) {
      var block = $('[data-tcs-bn-cart]'); if (!block) return;
      var n = 0, n100 = 0;
      (cart.items || []).forEach(function (i) {
        if (i.product_type === 'Discovery set') return;
        if (i.variant_title === '50 ml') n += i.quantity;
        else if (i.variant_title === '100 ml') { n += i.quantity; n100 += i.quantity; }
      });
      block.setAttribute('data-n', n); block.setAttribute('data-n100', n100); block.setAttribute('data-total', cart.total_price);
      var sbc = $('#site-cart-sidebar'); if (sbc) { var cnt = cart.item_count || 0; sbc.classList.toggle('cart-is-empty', cnt === 0); if (sbc.getAttribute('data-cart-items') !== String(cnt)) sbc.setAttribute('data-cart-items', cnt); }
      var tot = $('#site-cart-sidebar .cart__total strong'); if (tot) tot.removeAttribute('data-bn-done');
      renderCart();
    }).catch(function () {});
  }

  // Ærlig urgency: hverdage før kl. 13 dansk tid → "sender vi i dag", ellers næste hverdag.
  function shipLine() {
    var cut = (C.ship && C.ship.cutoff) || 13;
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Copenhagen', hour: 'numeric', hour12: false, weekday: 'short' }).formatToParts(new Date());
      var hour = Number((parts.filter(function (p) { return p.type === 'hour'; })[0] || {}).value), wd = (parts.filter(function (p) { return p.type === 'weekday'; })[0] || {}).value;
      var weekday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(wd) > -1;
      if (weekday && hour < cut) return '<b>Bestil inden kl. ' + cut + '</b>, så sender vi i dag';
      if (wd === 'Fri' || wd === 'Sat') return 'Sendes mandag';
    } catch (err) {}
    return 'Sendes i morgen';
  }

  function cartNeedsRender() {
    var cpx = $('#site-cart-sidebar contribe-plugin'); if (cpx && cpx.previousElementSibling !== $('#site-cart-sidebar .tcs-cart-usps')) return true;
    if ($('[data-tcs-upsell] [data-tcs-bn-cart]')) return true;
    if ($('#site-cart-sidebar .cart-item__price:not([data-bn-done])')) return true;
    if ($('#site-cart-sidebar .sidebar__title:not([data-bn-done])')) return true;
    if ($('#site-cart-sidebar .flex-buttons') && !$('#site-cart-sidebar [data-bn-trust]')) return true;
    if ($('#site-cart-sidebar .cart-item .cart-item__variant') && !$('#site-cart-sidebar [data-bn-up]') && $$('#site-cart-sidebar .cart-item__variant').some(function (v) { return /50/.test(v.textContent) && !/100/.test(v.textContent); })) return true;
    if ($('#site-cart-sidebar #AjaxCartForm') && (!$('#site-cart-sidebar .cart-item') !== !!$('#site-cart-sidebar [data-bn-cart-empty]'))) return true;
    if ($('#site-cart-sidebar .cart__total strong:not([data-bn-done])') && $('#site-cart-sidebar .cart-item')) return true;
    var t = $('#site-cart-sidebar .tcs-cart-upsell__title');
    if (t && !t.hasAttribute('data-bn-done')) return true;
    return !!$('#site-cart-sidebar [data-tcs-upsell-price]:not([data-bn-done])');
  }


  /* ---------- v2: segmenteret størrelsesvalg i hero ---------- */
  function renderSizeSeg() {
    $$('[data-bn-sizeseg] button').forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-size')) === hero.size)); });
  }

  /* ---------- v2: "Vælg til pakken" + pakke-bar ----------
     Kortene har data-v50 / data-v100 (variant-id) fra Liquid. Et tryk på + lægger
     duften i en lokal pakke; alle priser i gitteret falder til pakkens trin, og
     baren i bunden siger kun én ting: hvad én mere gør. Knappen lægger alle valgte
     varianter i kurven i ét kald og åbner draweren. ---------- */
  var picks = [];
  function picksRoot() { return $('[data-tcs-bn-picks]'); }
  function packMode() { return !!$('[data-tcs-bn-pbar]'); } // sider med pakke-bar: + lægger i pakken, ikke direkte i kurven
  function cardHandle(c) { return c.getAttribute('data-handle') || c.getAttribute('data-bn-handle'); }
  function pickCards() { return $$('[data-bn-card], .product-item[data-bn-handle]'); }
  function krownPrice(n) { return dk(n) + ',00 kr'; } // Krowns prisformat på kortene
  function renderPicks() {
    var root = picksRoot(); if (root) root.hidden = false;
    var sp = sale(), size = hero.size, w = PRICE[size].was, target = hero.n || 5;
    var n = picks.length, liveN = Math.max(n, target), u = sp ? per(size, liveN) : w;
    pickCards().forEach(function (c) {
      var on = picks.indexOf(cardHandle(c)) > -1;
      var btn = $('[data-bn-pick], [data-bn-qa]', c);
      if (btn) { btn.setAttribute('aria-pressed', String(on)); btn.classList.toggle('is-picked', on); btn.textContent = on ? '✓' : '+'; }
      var cb = $('[data-bn-card-badge]', c); if (cb) { cb.hidden = !(sp && liveN >= 3); if (!cb.hidden) { cb.innerHTML = badge(pct(liveN)); badgeClass(cb, pct(liveN)); } }
      var sz = $('[data-bn-card-size]', c); if (sz) sz.textContent = size + ' ml';
      var pr = $('[data-bn-card-price]', c); if (pr) pr.innerHTML = P(u);
      var was = $('[data-bn-card-was]', c); if (was) { was.textContent = sp ? Ptxt(w) : ''; was.hidden = !sp; }
      // Krowns kort: prisen følger pakkens trin (kun 50 ml-kort; 100 ml vælges på produktsiden)
      var kp = c.classList.contains('product-item') && c.querySelector('.product-price .current-price');
      if (kp && sp && packMode()) { if (!kp.hasAttribute('data-bn-orig')) kp.setAttribute('data-bn-orig', kp.textContent); kp.textContent = krownPrice(per(50, liveN)); }
      var lv = c.querySelector('.tcs-bn-card__lv'); if (lv && sp && packMode()) lv.innerHTML = liveN >= 3 ? '<b>−' + pct(liveN) + ' %</b> i din pakke på ' + liveN : '<b>−35 %</b> ved 3 · <b>−45 %</b> ved 5';
    });
    $$('[data-bn-live]').forEach(function (live) {
      live.innerHTML = !sp ? 'Normalpris i dag. Rabatterne starter 1. november.'
        : n === 0 ? 'Tryk + på <b>' + target + (target > 1 ? ' dufte' : ' duft') + '</b>.'
        : n < target ? '<b>' + n + ' af ' + target + ' valgt.</b> ' + (target - n) + ' mere, så har du −' + pct(target) + ' % på alle.'
        : '<b>' + n + (n > 1 ? ' dufte' : ' duft') + ' valgt · −' + pct(n) + ' %.</b> Tryk "Læg i kurv" nederst.';
    });
    var bar = $('[data-tcs-bn-pbar]');
    if (bar) {
      var onCollection = !!$('[data-tcs-bn-colhead]');
      var show = sp && (n > 0 || onCollection);
      bar.classList.toggle('is-on', show); bar.classList.toggle('is-empty', n === 0); document.body.classList.toggle('tcs-bn-has-pbar', show);
      if (show && n === 0) {
        // Tom tilstand på kollektionssider: missionen står i tommelfingerzonen, mens man scroller
        $('[data-bn-pbar-l]', bar).innerHTML = 'Vælg ' + target + ' dufte<b>Tryk + på kortene</b>';
        var pb0 = $('[data-bn-pbar-badge]', bar); if (pb0) { pb0.innerHTML = badge(pct(target)); badgeClass(pb0, pct(target)); }
        $$('[data-bn-pbar-dots] i', bar).forEach(function (d) { d.classList.remove('is-on'); });
        $('[data-bn-pbar-nx]', bar).innerHTML = 'Rabatten trækkes i kurven.';
      }
      if (show && n > 0) {
        var next = n < 3 ? { need: 3 - n, u: per(size, 3) } : n < 5 ? { need: 5 - n, u: per(size, 5) } : null;
        var uNow = per(size, n); // det, man betaler for de valgte lige nu (ikke målets pris)
        $('[data-bn-pbar-l]', bar).innerHTML = n + (n > 1 ? ' dufte' : ' duft') + ' i pakken<b>' + Ptxt(uNow * n) + ' i alt · ' + Ptxt(uNow) + ' pr. flaske</b>';
        var pb = $('[data-bn-pbar-badge]', bar); if (pb) { pb.innerHTML = badge(pct(n)); badgeClass(pb, pct(n)); }
        $$('[data-bn-pbar-dots] i', bar).forEach(function (d, i) { d.classList.toggle('is-on', i < n); });
        $('[data-bn-pbar-nx]', bar).innerHTML = next ? 'Læg <b>' + next.need + ' mere</b> i pakken, og få <b>−' + (n < 3 ? 35 : 45) + ' %</b> på alle' + (n === 2 ? ' og fri fragt.' : '.') : '<b>−45 %</b> på alt i pakken. Mere bliver det ikke.';
        var cta = $('[data-bn-pbar-cta]', bar); if (cta && !cta.disabled) cta.textContent = pickErr ? 'Prøv igen' : 'Læg ' + n + ' i kurven';
      }
      var nxEl = $('[data-bn-pbar-nx]', bar); if (nxEl) { nxEl.classList.toggle('is-error', !!pickErr); if (pickErr) nxEl.textContent = pickErr; }
    }
  }
  var vcache = {}; // handle+størrelse → promise med variant-id (varmes op, når duften vælges, så "Læg i kurven" ikke venter)
  var pickErr = '', adding = false;
  function withTimeout(p, ms, msg) { return new Promise(function (res, rej) { var t = setTimeout(function () { rej(new Error(msg || 'timeout')); }, ms); p.then(function (v) { clearTimeout(t); res(v); }, function (e) { clearTimeout(t); rej(e); }); }); }
  function variantFor(handle) {
    // Picks-gitterets kort har variant-id'er med; Krowns kort slås op via /products/<handle>.js
    var c = $('[data-bn-card][data-handle="' + handle + '"]');
    var id = c && Number(c.getAttribute(hero.size === 100 ? 'data-v100' : 'data-v50'));
    if (id) return Promise.resolve({ id: id, handle: handle });
    var ck = handle + ':' + hero.size; if (vcache[ck]) return vcache[ck];
    // Kun den valgte størrelse. Er den udsolgt, lægges der IKKE en anden størrelse i (det var en fælde før).
    // Fejl og "udsolgt" caches ikke, så et nyt forsøg slår op igen.
    return vcache[ck] = fetch('/products/' + handle + '.js').then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).then(function (p) {
      var want = hero.size === 100 ? /^100\s*ml$/i : /^50\s*ml$/i;
      var v = (p.variants || []).filter(function (x) { return want.test(x.title) && x.available; })[0];
      if (!v) { delete vcache[ck]; return { id: null, handle: handle, title: p.title, soldOut: true }; }
      return { id: v.id, handle: handle, title: p.title };
    }).catch(function () { delete vcache[ck]; return { id: null, handle: handle, title: handle.toUpperCase(), failed: true }; });
  }
  // Åbn kurven med det samme, og skriv "Lægger n dufte i kurven …", mens Shopify arbejder (0,6–0,9 s).
  function setAdding(n) {
    var sb = $('[data-js-site-cart-sidebar]');
    document.documentElement.classList.toggle('tcs-bn-adding', n > 0);
    var txt = n > 0 ? 'Lægger ' + n + (n > 1 ? ' dufte' : ' duft') + ' i kurven …' : '';
    var emp = $('#site-cart-sidebar [data-bn-cart-empty]'); if (emp) { var ap = emp.querySelector('[data-bn-adding]'); if (!ap) { ap = document.createElement('p'); ap.setAttribute('data-bn-adding', '1'); ap.className = 'tcs-bn-cart-empty__adding'; emp.insertBefore(ap, emp.firstChild); } setText(ap, txt); }
    var nx = $('#site-cart-sidebar [data-bn-cart-nx]'); if (nx && n > 0) setHTML(nx, txt);
    if (n > 0 && sb && typeof sb.show === 'function') { try { sb.show(); } catch (err) {} }
  }
  // Sektionerne fra add.js-svaret sættes direkte ind (det, Krowns refreshCart og Growbix' refreshUpsell ellers henter bagefter).
  function applySections(sec) {
    if (!sec) return false;
    var ok = false;
    try {
      if (sec['helper-cart']) {
        var doc = new DOMParser().parseFromString(sec['helper-cart'], 'text/html');
        var form = doc.getElementById('AjaxCartForm'), sub = doc.getElementById('AjaxCartSubtotal');
        var cur = document.getElementById('AjaxCartForm'), curSub = document.getElementById('AjaxCartSubtotal');
        if (form && cur) {
          cur.innerHTML = form.innerHTML; if (typeof cur.ajaxifyCartItems === 'function') cur.ajaxifyCartItems();
          var cnt = cur.querySelector('[data-cart-count]'), tot = cur.querySelector('[data-cart-total]');
          if (cnt) $$('[data-header-cart-count]').forEach(function (e) { e.textContent = cnt.textContent; });
          if (tot) $$('[data-header-cart-total]').forEach(function (e) { e.textContent = tot.textContent; });
          var sbEl = $('#site-cart-sidebar'); if (sbEl && cnt) { var c = Number(cnt.textContent) || 0; sbEl.classList.toggle('cart-is-empty', c === 0); sbEl.setAttribute('data-cart-items', c); }
          ok = true;
        }
        if (sub && curSub) curSub.innerHTML = sub.innerHTML;
      }
      if (sec['cart-drawer']) {
        var doc2 = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html');
        var up = doc2.querySelector('[data-tcs-upsell]'), curUp = $('[data-tcs-upsell]');
        if (up && curUp) curUp.innerHTML = up.innerHTML;
      }
    } catch (err) { ok = false; }
    return ok;
  }
  function addPicksToCart() {
    if (!picks.length || adding) return;
    adding = true; pickErr = '';
    var n = picks.length, chosen = picks.slice();
    var btn = $('[data-bn-pbar-cta]'); if (btn) { btn.disabled = true; btn.textContent = 'Lægger i kurv …'; }
    setAdding(n);
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null, hard = setTimeout(function () { if (ctrl) ctrl.abort(); }, 15000);
    var missing = [];
    withTimeout(Promise.all(chosen.map(variantFor)), 8000, 'Opslaget tog for lang tid').then(function (vs) {
      var items = [];
      vs.forEach(function (v) { if (v && v.id) items.push({ id: v.id, quantity: 1 }); else if (v) missing.push(v); });
      if (!items.length) throw new Error(missing.length && missing[0].soldOut ? (missing[0].title + ' er udsolgt i ' + hero.size + ' ml.') : 'Kunne ikke finde flaskerne. Prøv igen.');
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items, sections: 'helper-cart,cart-drawer' }), signal: ctrl ? ctrl.signal : undefined });
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || d.message || 'Kunne ikke lægge i kurven.'); return d; }); })
      .then(function (d) {
        clearTimeout(hard); adding = false;
        // Kun de flasker, der faktisk kom i kurven, forlader pakken; udsolgte bliver stående med besked.
        picks = picks.filter(function (h) { return missing.some(function (m) { return m.handle === h; }); });
        if (missing.length) pickErr = missing.map(function (m) { return m.title; }).join(', ') + (missing.length > 1 ? ' er' : ' er') + ' udsolgt i ' + hero.size + ' ml og blev ikke lagt i.';
        if (btn) { btn.disabled = false; btn.textContent = 'Læg i kurv'; }
        setAdding(0); renderPicks();
        var applied = applySections(d.sections);
        if (!applied && typeof window.refreshCart === 'function') { try { window.refreshCart(); } catch (err) {} }
        else { var sb = $('[data-js-site-cart-sidebar]'); if (sb && typeof sb.show === 'function') { try { sb.show(); } catch (err) {} } }
        syncFromCart();
        document.dispatchEvent(new CustomEvent('cart-updated'));
      })
      .catch(function (err) {
        clearTimeout(hard); adding = false;
        pickErr = (err && err.name === 'AbortError') ? 'Det tog for lang tid. Prøv igen.' : ((err && err.message) || 'Kunne ikke lægge i kurven. Prøv igen.');
        if (btn) { btn.disabled = false; }
        setAdding(0); renderCart(); renderPicks();
        var sbx = $('#site-cart-sidebar'), close = $('#site-cart-sidebar [data-js-close]');
        if (sbx && sbx.classList.contains('cart-is-empty')) { if (close) close.click(); }
        else { var cnx = $('#site-cart-sidebar [data-bn-cart-nx]'); if (cnx) { cnx.textContent = pickErr; cnx.classList.add('is-error'); } }
      });
  }
  function togglePick(handle) { pickErr = ''; var i = picks.indexOf(handle); if (i > -1) picks.splice(i, 1); else { picks.push(handle); variantFor(handle); } renderPicks(); }
  // Kollektionssider: "Tryk + på 5 dufte." flyttes ned under Growbix' filter/sortering, lige over kortene med + (Omar 4/11).
  function placeLiveLine() {
    var live = $('[data-tcs-bn-colhead] [data-bn-live]'), f = $('.collection-all-sec .tcs-filters');
    if (live && f && !live.hasAttribute('data-bn-moved')) { live.setAttribute('data-bn-moved', '1'); live.classList.add('tcs-bn-live--grid'); f.insertAdjacentElement('afterend', live); }
  }
  function initPicks() {
    placeLiveLine();
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-bn-pick]'); if (!b) return;
      e.preventDefault(); togglePick(cardHandle(b.closest('[data-bn-card]')));
    });
    var bar = $('[data-tcs-bn-pbar]');
    if (bar) bar.addEventListener('click', function (e) { if (e.target.closest('[data-bn-pbar-cta]')) { e.preventDefault(); addPicksToCart(); } });
    renderPicks();
  }

  /* ---------- faseskift uden reload ---------- */
  function applyPhase() {
    document.documentElement.setAttribute('data-tcs-bn-phase', C.phase);
    renderTopbar(); decorateCards(); renderOffer(); renderCart(); renderPDP(); fixModuleUnits(); tick();
  }
  function recheck() {
    var p = C.resolve();
    if (p === C.phase) return;
    if (p === 'off') { location.reload(); return; }
    C.phase = p; applyPhase();
  }

  function init() {
    renderTopbar(); initCards(); initHero(); initPicks(); renderPDP(); initModule(); renderCart(); tick();
    setInterval(tick, 1000);
    setInterval(recheck, 30000);
    // Kurven: Growbix' drawer udskifter upsell-containeren ved hver ændring, og
    // Krowns refreshCart udskifter kurvformularen. Begge dele fanges her.
    var mo = new MutationObserver(function () { if (cartNeedsRender()) renderCart(); });
    var sb = $('#site-cart-sidebar');
    if (sb) mo.observe(sb, { childList: true, subtree: true });
    var subEl = $('#AjaxCartSubtotal'), syncT = null;
    if (subEl) new MutationObserver(function () { clearTimeout(syncT); syncT = setTimeout(syncFromCart, 30); }).observe(subEl, { childList: true });
    // Growbix' handleAddToCart genindlæser kurven to gange (0 og 1,6 s) af hensyn til Cartbots gave.
    // Cartbot er slået fra i kampagnen, så én genindlæsning er nok; det fjerner det andet "blink".
    if (typeof window.handleAddToCart === 'function') {
      window.handleAddToCart = function (body, count, headers, done) {
        fetch('/cart/add.js', { method: 'POST', headers: headers, body: body }).then(function (r) { return r.json(); })
          .then(function (d) { if (!d.status) { syncFromCart(); if (typeof window.refreshCart === 'function') window.refreshCart(); } })
          .catch(function () {}).finally(done);
      };
    }
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('[data-tcs-upsell-select]')) { var pr = e.target.closest('.tcs-cart-upsell__item'); pr = pr && pr.querySelector('[data-tcs-upsell-price]'); if (pr) pr.removeAttribute('data-bn-done'); setTimeout(renderCart, 0); } });
    document.addEventListener('cart-updated', function () { setTimeout(renderCart, 50); });
    // Growbix' faner skifter paneler klient-side, men i kampagnen renderes kun den aktuelle kollektion
    // (hastighed). Et tryk på en anden fane går derfor til den kollektions egen side.
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('.head-bar .tabs [id^="btn-"]'); if (!b) return;
      var h = b.id.replace(/^btn-/, ''), cur = (location.pathname.match(/\/collections\/([^/?#]+)/) || [])[1];
      if (!h || h === cur) return;
      e.preventDefault(); e.stopImmediatePropagation(); location.href = '/collections/' + h;
    }, true);
    document.addEventListener('click', function (e) {
      var up = e.target && e.target.closest && e.target.closest('[data-bn-up]'); if (!up) return;
      e.preventDefault();
      var it = up.closest('.cart-item'); if (!it || up.disabled) return;
      var key = it.getAttribute('data-id'), q = Number(it.getAttribute('data-qty')) || 1;
      var a = it.querySelector('.cart-item__title') || it.querySelector('.cart-item__thumbnail');
      var m = a && /\/products\/([^?#/]+)/.exec(a.getAttribute('href') || ''); if (!m || !key) return;
      up.disabled = true; up.setAttribute('aria-busy', 'true');
      // Ét kald: 50 ml-linjen til 0 og 100 ml til samme antal (update.js lægger varianten i, hvis den ikke findes).
      Promise.all([fetch('/products/' + m[1] + '.js').then(function (r) { return r.json(); }), getCart(true)]).then(function (res) {
        var p = res[0], cart = res[1];
        var v = (p.variants || []).filter(function (v) { return /100/.test(v.title) && v.available; })[0];
        if (!v) throw new Error('ingen 100 ml');
        var vid50 = Number(String(key).split(':')[0]);
        var line = (cart.items || []).filter(function (i) { return i.variant_id === vid50; })[0];
        var updates = {}; updates[line ? line.key : key] = 0; updates[String(v.id)] = q + ((cart.items || []).filter(function (i) { return i.variant_id === v.id; })[0] || { quantity: 0 }).quantity;
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) }).then(function (r) { if (!r.ok) throw new Error('update'); return r.json(); });
      }).then(function () { if (typeof window.refreshCart === 'function') window.refreshCart(); })
        .catch(function () { up.disabled = false; up.removeAttribute('aria-busy'); up.innerHTML = '100 ml er udsolgt i denne duft'; });
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
